export default __webpack_public_path__ + "static/media/i192bp.418f0e6c.webp";